<div class="endpoints-container">
  <app-sidenav-header title="{{'INSTANCE_LIST.ENDPOINTS' | transloco }}"></app-sidenav-header>
  <ng-container *ngFor="let endpoint of data.endpoints">
    <div class="table-tr mb-16">
      <div class="flex flex-col endpoint-row mb-8">
        <div class="flex justify-between items-center row-content p-16">
          <span class="fw-700">{{endpoint.name}}</span>
          <div class="flex justify-center items-center mr-16">
            <span (click)="onCopiedUrl()" [cdkCopyToClipboard]="endpoint.url"
              class="copy-url mat-body fw-500 mr-20 copy-bottom">{{'VIEW_ENDPOINTS.COPY_URL' | transloco}}</span>
            <button class="white rounded" (click)="urlService.openUrlInNewTab(endpoint.url)">
              <div class="flex justify-center items-center">
                <mat-icon svgIcon="open_in_new" class="icon-sm mr-12"></mat-icon>
                <span class="fs-16">{{'VIEW_ENDPOINTS.OPEN' | transloco}}</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
